/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Cve1
 */
export interface Cve1 {
}

/**
 * Check if a given object implements the Cve1 interface.
 */
export function instanceOfCve1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Cve1FromJSON(json: any): Cve1 {
    return Cve1FromJSONTyped(json, false);
}

export function Cve1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Cve1 {
    return json;
}

export function Cve1ToJSON(value?: Cve1 | null): any {
    return value;
}

